@if (model?.data) {
<div class="w-12 flex flex-top"
     sizeClass="XL: p2, MS: p3">
    <div class="overflow-hidden"
         [ngClass]="model.giftCard?.isGiftcard ? 'ratio-3-2' : 'ratio-3-4'"
         [class.giftcardItemImage]="model.giftCard?.isGiftcard"
         [style.width]="'112px'"
         [style.min-width]="'112px'">
        <shell></shell>
        <img class="rf"
             [image]="image">
    </div>
    <div class="flex-grow p-l-3 p-l-4-s">
        <div class="flex flex-justify-between">
            <p class="p1">{{model.data?.name}}</p>
            <price class="s2 p-t-1 p-l-1"
                   [value]="item.rowPrice"
                   precision="2">
            </price>
        </div>
        <p class="p2 m-t-3 col-12">{{model.data?.size | optionLabel : 'size'}}@if (model.data?.size &&
            model.data?.color) {
            <span>&nbsp;|&nbsp;</span>
            } {{model.data?.color |
            optionLabel : 'color'}}
        </p>
        <p class="p2 m-t-1 col-12">{{'Qty: %' | translate : item.qty}}</p>
    </div>
</div>
}